import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function mr3(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@mr3/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@mr3/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@mr3/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@mr3/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@mr3/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@mr3/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}